import { eventsKeys } from '../constants';
import send from './send';

export default () => {
  send(eventsKeys.DOWNLOAD_PDF_FROM_POPUP);
};
